// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownMenu_dropdown__3-yeR"};